export default __webpack_public_path__ + "static/media/batch-submit.f577ebfe.png";